import React, { useEffect, useMemo, useState } from "react"
import TableContainer from "components/Common/TableContainer"
import { getTableSortingHeaderIcon } from "helpers/common"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
import { useLazyGetProfileDeletionsQuery } from "store/api/profile/profile.api"
import { Container } from "reactstrap"
import { usePermission } from "hooks/usePermission"
import moment from "moment"
import Breadcrumb from "components/Common/Breadcrumb"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const AccountDeletions = ({ type }) => {
  const [getResults, { isFetching }] = useLazyGetProfileDeletionsQuery()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const { hasPermission } = usePermission()

  //meta title
  document.title = "Account Deletions | Prachay"

  useEffect(() => {
    getList()
  }, [filters, type])

  const getList = async () => {
    try {
      const { data } = await getResults({ ...filters, type }).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  const getStatus = (key) => {
    let status = "Active"
    let className = "Active"

    switch (key) {
      case "PENDING":
        status = "Pending"
        className = "kyc_pending"
        break

      case "DELETED":
        status = "Deleted"
        className = "rejected"
        break

      case "CANCELLED":
        status = "Reactivated"
        className = "link_expired"
        break

      default:
        status = "Cancelled"
        className = "link_expired"
        break
    }

    return (
      <div className={`badge ${className}`}>
        <span></span> {status}
      </div>
    )
  }

  const columns = useMemo(() => {
    const baseColumns = [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
        accessorKey: "formatted_created_at",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        header: ({ column }) => getTableSortingHeaderIcon(column, "Name"),
        cell: ({ row }) => (
          <DefaultAvatar
            avatar_url={
              row?.original.investor?.avatar_url ||
              row?.original.wealthPartner?.avatar_url
            }
            email={
              row?.original.investor?.email ||
              row?.original.wealthPartner?.email
            }
            name={
              row?.original.investor?.name || row?.original.wealthPartner?.name
            }
          />
        ),
      },
      {
        header: "Reason",
        accessorKey: "reason",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Reactivate Till",
        accessorKey: "deleting_on",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">
            {row?.original?.status === "PENDING"
              ? moment(row?.original?.deleting_on).format("D MMM YYYY, HH:mm A")
              : "Not Applicable"}
          </div>
        ),
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">{getStatus(row?.original?.status)}</div>
        ),
      },
    ]

    return baseColumns
  }, [type, hasPermission])

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={"Account Deletions"}
            breadcrumbItem={"Investors"}
          />
          <TableContainer
            isLoading={isFetching}
            count={count}
            filters={filters}
            setFilters={setFilters}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isCustomPageSize={true}
            // isGlobalFilter={true}
            isPagination={true}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </Container>
      </div>
    </>
  )
}

export default AccountDeletions
